


//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Background from '../../components/background/Background.jsx'
import ProgressBar from '../../components/progressbar/ProgressBar.jsx'
import ResaValidate from '../../components/resavalidate/ResaValidate.jsx'
import Comments from '../../components/comments/Comments.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getFormules, getEleves, getFormulesEleves, getClient } from "../../store/selectors.js";
import { clientSlice } from "../../store/clientSlice.js";
import { elevesSlice } from "../../store/elevesSlice.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//Utils 
import creneauxSorter from '../../utils/creneaux_sorter.js';
import convertHoraire from '../../utils/convert_horaire.js';
import elevesSorter from '../../utils/eleves_sorter.js';

//MUI :
import Button from '@mui/material/Button';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';

import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';

import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function ClientInfos({ setFormValid }) { // full page as component imported in router


    const navigate = useNavigate();
    const dispatch = useDispatch();
    let selectedCreneaux = useSelector(getSelectedCreneaux);
    let theClient = useSelector(getClient);
    const lang = useSelector(getLang) //global state : language






    const [phone, setPhone] = useState([])
    const [phone2, setPhone2] = useState([])
    const [phoneError, setPhoneError] = useState(false)
    const [phoneError2, setPhoneError2] = useState(false)
    const [prenomError, setPrenomError] = useState(false)
    const [nomError, setNomError] = useState(false)
    const [telFound, setTelFound] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [showFail, setShowFail] = useState(false)
    const [tempClient, setTempClient] = useState()
    const [tryCpt, setTryCpt] = useState(0)
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(false);

    //// -- at first render :
    /*  useEffect(() => {
         //security : redirect
         console.log(selectedCreneaux);
         if (selectedCreneaux.length === 0 || theClient.length === 0) {
             navigate("../calendar");
         }
     }) */
    //// -- 

    //// -- at first render :
    useEffect(() => {

        checkValid();

    }, [phone, theClient])
    //// -- 

    const handleChangePhone = (newValue, info) => {
        setPhone([newValue, info]);

        if (matchIsValidTel(newValue)) {
            setPhoneError(false);
            findClient(info.numberValue);
        }
        else {
            setPhoneError(true);
        }
    }

    const handleChangePhone2 = (newValue, info) => {
        setPhone2([newValue, info]);
        handleClientChange(info.numberValue, "tel2");

        if (matchIsValidTel(newValue)) {
            setPhoneError2(false);
        }
        else {
            //setPhoneError2(true);
        }
    }

    function handleClientChange(value, champ) {
        //setEmail(e.target.value);

        dispatch(clientSlice.actions.setClient(
            {
                id_client: theClient.id_client,
                prenom: champ === "prenom" ? value : theClient.prenom,
                nom: champ === "nom" ? value : theClient.nom,
                email: champ === "email" ? emailCleaner(value) : theClient.email,
                tel: champ === "tel" ? value : theClient.tel,
                tel2: champ === "tel2" ? value : theClient.tel2,
                adresse_vacances: champ === "adresse" ? value : theClient.adresse_vacances,
                is_eleve: false,
                eleve_id: 0
            }
        ));

        if (champ === "tel") { console.log(value) }
        if (champ === "prenom") {
            value.length === 0 ? setPrenomError(true) : setPrenomError(false)
        }
        if (champ === "nom") {
            value.length === 0 ? setNomError(true) : setNomError(false)
        }

        if (champ === "email") {
            const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
            if (emailRegex.test(value)) {
                setEmailError(false);
                if (telFound) { confirmMail(value) } // if tel already exist (as new client), let's compare with stored email
            } else {
                setEmailError(true);
            }
        }
    }


    function emailCleaner(raw) {
        let clean = raw.toLowerCase();
        clean = clean.split(" ").join("");
        return clean
    }

    function confirmMail(emailInput) {

        if (emailInput === tempClient.email) {
            dispatch(clientSlice.actions.setClient(tempClient));
            setShowAlert(false);
            setPhoneError(false);
        }

    }

    async function findClient(number) {

        console.log(number);
        let result = await getOneClient(number);

        if (result.length > 0) { //client found
            setTelFound(true);
            setTempClient(result[0]);

            if (result[0].email === theClient.email) {
                dispatch(clientSlice.actions.setClient(result[0]));
                setShowAlert(false);
                setPhoneError(false);
            }
            else {
                handleClientChange("", "tel");
                setShowAlert(true);
                setPhoneError(true);
            }
        }
        else { //not found
            setTelFound(false);
            handleClientChange(number, "tel");
            setShowAlert(false);
        }


    }



    async function getOneClient(number) { // get list of formules from DB

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/client/phone/${number}`,
            });
            //console.log(response.data.data);
            if (response.status === 200) {
                const client = response.data.data;
                return client;
            }
            else {
                return [];
            }
        } catch (err) {
            console.error(err);
            return [];
        }
    }


    function checkValid() {
        let valid = false;

        if (theClient.length > 0) {
            valid = (emailError === true || phoneError === true /* || phoneError2 === true */ || (!phone[0] && theClient.tel.length === 0) || theClient.email.length === 0 || theClient.prenom.length === 0 || theClient.nom.length === 0)
        }
        else {
            valid = (emailError === true || phoneError === true /* || phoneError2 === true */ || (!phone[0] && theClient.tel.length === 0) || theClient.email.length === 0 || theClient.prenom.length === 0 || theClient.nom.length === 0)

        }
        console.log(valid)
        setFormValid(!valid)

    }

    return (

        <div className="client-infos">
            <h3>{translator("Vos contacts", lang, "formInfosTitle")}</h3>

            <div className="client-infos-form">
                <div className="client-infos-form-left">

                    <div className="client-infos-form-left-top">
                        <MuiTelInput
                            className="client-infos-form-tel"
                            label={translator("Téléphone", lang, "formInfosPhone")}
                            error={phoneError}
                            required
                            forceCallingCode
                            focusOnSelectCountry
                            defaultCountry="FR"
                            preferredCountries={['FR', 'BE', 'DE', 'NL', 'ES', 'IT', 'GB', 'US']}
                            disabled={theClient.id_client > 0}
                            value={theClient.id_client > 0 ? theClient.tel : phone[0]/* theClient.tel */}
                            onChange={handleChangePhone} />
                        {showAlert === true &&
                            <Alert className="client-infos-form-tel-alert" severity="error">Ce numéro est déjà utilisé;-)<br />- Renseignez l'email correspondant à ce numéro pour retrouver vos coordonnées.<br />- Sinon, utilisez un autre numéro</Alert>
                        }

                    </div>

                    <div className="client-infos-form-left-bottom">
                        <TextField
                            className="client-infos-form-email"
                            required
                            label={translator("Email", lang, "formInfosMail")}
                            value={theClient.email}
                            onChange={e => handleClientChange(e.target.value, "email")}
                            error={emailError}
                            helperText={emailError ? "Please enter a valid email" : ""}
                            inputProps={{
                                type: "email",
                            }}
                        />

                    </div>

                </div>

                <div className="client-infos-form-right">
                    <div className="client-infos-form-right-top">
                        <TextField
                            className="client-infos-form-prenom"
                            required
                            label={translator("Prénom", lang, "formInfosPrenom")}
                            value={theClient.prenom}
                            onChange={e => handleClientChange(e.target.value, "prenom")}
                            error={prenomError}
                            helperText={prenomError ? "Le prénom est requis" : ""}
                        />
                        <TextField
                            className="client-infos-form-nom"
                            required
                            label={translator("Nom", lang, "formInfosNom")}
                            value={theClient.nom}
                            onChange={e => handleClientChange(e.target.value, "nom")}
                            error={nomError}
                            helperText={nomError ? "Le nom est requis" : ""}
                        />

                    </div>

                    <div className="client-infos-form-right-bottom">

                        <MuiTelInput
                            className="client-infos-form-tel2"
                            label={translator("Téléphone 2 - facultatif", lang, "formInfosPhone2")}
                            error={phoneError2}
                            forceCallingCode
                            focusOnSelectCountry
                            defaultCountry="FR"
                            preferredCountries={['FR', 'BE', 'DE', 'NL', 'ES', 'IT', 'GB', 'US']}
                            value={theClient.tel2}
                            onChange={handleChangePhone2} />
                        <TextField
                            fullWidth
                            className="client-infos-form-adresse"
                            label={translator("Adresse de vacances - facultatif", lang, "formInfosAddress")}
                            value={theClient.adresse_vacances}
                            onChange={e => handleClientChange(e.target.value, "adresse")}
                        />
                    </div>
                </div>
            </div>


        </div>


    );
}

export default ClientInfos;